import {lazy} from 'react'
import {USER_ROLES} from 'modules/auth/utils/const'

export default [
  {
    isProtected: true,
    exact: true,
    customLayout: false,
    path: '/interactions',
    component: lazy(() => import('./MeetGreetsOverview')),
    roles: [USER_ROLES.ADMIN, USER_ROLES.OPS, USER_ROLES.PARTNER],
  },
  {
    isProtected: true,
    exact: true,
    customLayout: true,
    path: '/interactions/overview/fragments',
    component: lazy(() => import('./MeetGreetsOverview')),
    roles: [USER_ROLES.ADMIN, USER_ROLES.OPS, USER_ROLES.PARTNER],
  },
  {
    isProtected: true,
    exact: true,
    customLayout: true,
    path: '/interactions/:meetGreetId/fragments',
    component: lazy(() => import('./MeetGreetDetails')),
    roles: [USER_ROLES.ADMIN, USER_ROLES.OPS, USER_ROLES.PARTNER],
  },
  {
    isProtected: true,
    exact: true,
    customLayout: false,
    path: '/interactions/:meetGreetId',
    component: lazy(() => import('./MeetGreetDetails')),
    roles: [USER_ROLES.ADMIN, USER_ROLES.OPS, USER_ROLES.PARTNER],
  },
]
